<template>
    <div
        v-if="shop && isOpen"
        class="_mobile_contact "
        :class="{active :isOpen}"
    >
        <h3 class="_adress" v-html="shop.address"></h3>

        <p class="_text">
            Тел.:
            <a :href="`tel:${shop.telephone}`">{{ shop.telephone }}</a>
            <br />
            Email:
            <a :href="`mailto:${shop.email}`">{{ shop.email }}</a>
        </p>

        <div class="_social">
            <a
                v-if="telegram && telegram.link"
                :href="telegram.link"
                target="_blank"
                class="_item"
            >
                <svg>
                    <use xlink:href="/assets/img/sprite.svg#telegram" />
                </svg>
            </a>

            <a
                v-if="whatsapp && whatsapp.link"
                :href="whatsapp.link"
                target="_blank"
                class="_item"
            >
                <svg>
                    <use xlink:href="/assets/img/sprite.svg#whatsapp" />
                </svg>
            </a>

            <a
                v-if="viber && viber.link"
                :href="viber.link"
                target="_blank"
                class="_item"
            >
                <svg>
                    <use xlink:href="/assets/img/sprite.svg#viber" />
                </svg>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        shop: {
            type: Object || null,
            default: null,
        },

        isOpen: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
